import { Menu, UnstyledButton, Group, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { TbChevronDown } from 'react-icons/tb'

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'cs', label: 'Česky' },
  { code: 'sk', label: 'Slovenčina' },
] as const

const LanguagePicker = () => {
  const { i18n } = useTranslation()
  const current = LANGUAGES.find(l => l.code === i18n.language) ?? LANGUAGES[0]

  return (
    <Menu shadow="md" width={120}>
      <Menu.Target>
        <UnstyledButton
          style={{
            padding: '4px 8px',
            borderRadius: '6px',
            border: '1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4))',
          }}
        >
          <Group gap={4}>
            <Text size="sm" fw={600} c="light-dark(#868e96, #c9c9c9)">
              {current.label}
            </Text>
            <TbChevronDown size={14} color="light-dark(#868e96, #c9c9c9)" />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {LANGUAGES.map(lang => (
          <Menu.Item
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            fw={i18n.language === lang.code ? 700 : 400}
          >
            {lang.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default LanguagePicker
